import { render, staticRenderFns } from "./Calendars.vue?vue&type=template&id=298cd7e4&"
import script from "./Calendars.vue?vue&type=script&lang=ts&"
export * from "./Calendars.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports